const btnasset = document.querySelectorAll(".btnasset");

if (btnasset) {
    btnasset.forEach(btn =>{
        btn.addEventListener("click",(ev)=>{
            let label = window.location.href;
            gtag("event", "download", {
                event_category: "descarga",
                event_label: label,
            });
        });
    });
}